import React, { FC } from 'react';
import { CommodityStatusCode, MilestoneStatusCode } from '@bechtel/types';
import { Text, Box, Icon, IconSize } from '@bechtel/gds';
import { WeldMilestoneMetadataProps } from './types';
import { useDate, useName } from '@bechtel/client-common';
import { Trans, t } from '@lingui/macro';
import { CountMetadata, UserMetadata } from '../../../metadata';

const UnassignedCrewMember = () => {
  return (
    <Box justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }}>
      <Icon size={IconSize.MEDIUM} icon="user" fillColor="blue.800" />
      <Box ml={{ sm: '500' }}>
        <Text size="400" color="grey.1000">
          <Trans>Unassigned</Trans>
        </Text>
      </Box>
    </Box>
  );
};

export const WeldMilestoneMetadata: FC<WeldMilestoneMetadataProps> = ({
  fitUpMilestone,
  commodityStatus,
  milestone,
  status,
  assignee,
}) => {
  const { formatISODate } = useDate();
  const { getFullName } = useName();
  if (
    (status === MilestoneStatusCode.CLAIMED || status === MilestoneStatusCode.APPROVED) &&
    milestone.currentStatus &&
    milestone.currentStatus.createdBy
  )
    return (
      <UserMetadata
        name={getFullName(milestone.currentStatus.createdBy.firstName, milestone.currentStatus.createdBy.lastName)}
        imageUrl={milestone.currentStatus.createdBy.imageUrl}
        startDate={formatISODate(milestone.currentStatus.createdAt)}
      />
    );

  if (status === MilestoneStatusCode.REQUESTED && milestone.currentStatus && milestone.currentStatus.createdBy)
    return (
      <UserMetadata
        name={getFullName(milestone.currentStatus.createdBy.firstName, milestone.currentStatus.createdBy.lastName)}
        imageUrl={milestone.currentStatus.createdBy.imageUrl}
        startDate={formatISODate(milestone.currentStatus.createdAt)}
      />
    );
  if (status === MilestoneStatusCode.BLOCKED && milestone.currentStatus && milestone.currentStatus.createdBy)
    return (
      <UserMetadata
        name={getFullName(milestone.currentStatus.createdBy.firstName, milestone.currentStatus.createdBy.lastName)}
        imageUrl={milestone.currentStatus.createdBy.imageUrl}
        startDate={formatISODate(milestone.currentStatus.createdAt)}
      />
    );

  if (status === MilestoneStatusCode.REJECTED) {
    return (
      <Box gap={{ sm: '200' }} flexDirection={{ sm: 'column' }}>
        <CountMetadata label={t`Rejection Count`} count={milestone.timesRejected} />
        <UserMetadata
          name={getFullName(milestone.currentStatus.createdBy?.firstName, milestone.currentStatus.createdBy?.lastName)}
          imageUrl={milestone.currentStatus.createdBy?.imageUrl}
          startDate={formatISODate(milestone.currentStatus.createdAt)}
        />
      </Box>
    );
  }

  if (assignee)
    return <UserMetadata name={getFullName(assignee.firstName, assignee.lastName)} imageUrl={assignee.imageUrl} />;
  if (!assignee) return <UnassignedCrewMember />;
  return null;
};
